/* eslint-disable react/no-danger */

import { useEffect, useContext, useCallback } from 'react';
import { connect } from 'react-redux';
import {
  PrivacySettingToggle,
  PrivacySettingToggles,
} from '@prisjakt/web-app-config/types/market';
import { AppContext } from '@prisjakt/ui-app-context';
import { pushEvent } from '../../client/data-layer';
import acceptCookiesAction from './actions';
import { AppState } from '../../reducers';

type OwnProps = {};

type StateProps = {
  version: string;
  settings: PrivacySettingToggle;
  isLoggedIn: boolean;
  isActive: boolean;
};

type DispatchProps = {
  acceptCookies: typeof acceptCookiesAction;
  rejectCookies: typeof acceptCookiesAction;
};

type Props = OwnProps & StateProps & DispatchProps;

const CookieBanner = ({
  acceptCookies,
  rejectCookies,
  settings,
  isLoggedIn,
}: Props) => {
  const { renderMode, market } = useContext(AppContext);
  const privacySettings =
    market &&
    market.privacySettings &&
    (market.privacySettings[renderMode] || market.privacySettings.responsive);
  const onAcceptCookies = useCallback(() => {
    acceptCookies(
      privacySettings.cookieVersion,
      {
        ...settings,
        [PrivacySettingToggles.BehaviorTrackingMarketing]: true,
      },
      isLoggedIn
    );
  }, [isLoggedIn, privacySettings, acceptCookies, settings]);

  const onRejectCookies = useCallback(() => {
    rejectCookies(
      privacySettings.cookieVersion,
      {
        ...settings,
        [PrivacySettingToggles.BehaviorTrackingMarketing]: false,
        [PrivacySettingToggles.BehaviorTrackingSurveys]: false,
        // Product Improvment (GA, Amplitude etc.) has been deemed OK to have enabled even if all
        // cookies were reject by the user
        [PrivacySettingToggles.BehaviourTrackingImprovement]: true,
        [PrivacySettingToggles.PersonalizedAds]: false,
        [PrivacySettingToggles.Personalization]: false,
      },
      isLoggedIn
    );
  }, [isLoggedIn, privacySettings, rejectCookies, settings]);

  const removeServerSideCookieBanner = (id: string) => {
    const element = document?.getElementById(id);
    if (!element) return;
    element.innerHTML = '';
  };

  const getCookie = (name: string) => {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i += 1) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  };
  useEffect(() => {
    const visible = !window.SESSION_DATA.session.cookie_consent_version;
    pushEvent('cookieBannerIsVisible', { visible });

    if (document) {
      if (!visible) {
        removeServerSideCookieBanner('root-cookiebanner');
      } else if (getCookie('cookie-banner-interaction') !== null) {
        removeServerSideCookieBanner('root-cookiebanner');
        if (getCookie('cookie-banner-interaction') === 'accepted')
          onAcceptCookies();
        else onRejectCookies();
      } else {
        const acceptButton = document?.getElementById(
          'AcceptButton-cookie-banner'
        );
        const rejectButton = document?.getElementById(
          'RejectButton-cookie-banner'
        );
        if (acceptButton !== null) {
          acceptButton.onclick = () => {
            onAcceptCookies();
          };
        }
        if (rejectButton !== null) {
          rejectButton.onclick = () => {
            onRejectCookies();
          };
        }
      }
    }
  }, []);

  return null;
};

const mapStateToProps = (state: AppState) => ({
  version: state.globals.cookieBanner.version,
  isActive: state.globals.cookieBanner.isActive,
  settings: state.areas.user.tracking.settings,
  isLoggedIn: state.areas.account.isAuthenticated,
});

const dispatchProps = {
  acceptCookies: acceptCookiesAction,
  rejectCookies: acceptCookiesAction,
};

export default connect(mapStateToProps, dispatchProps)(CookieBanner);
